/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/CheckBoxOutlineBlank';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const CheckBoxOutlineBlankIcon = withMuiAdapter(Base, 'CheckBoxOutlineBlank');
